/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connect_New_Tab_HintInputs */



/**
* | output |
* | --- |
* | "Opens in a new tab; your draft stays here." |
*
* @param {Connect_New_Tab_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connect_new_tab_hint = /** @type {((inputs?: Connect_New_Tab_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connect_New_Tab_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnet sich in einem neuen Tab; Ihr Entwurf bleibt hier erhalten.")
	return /** @type {LocalizedString} */ ("Opens in a new tab; your draft stays here.")
});